import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-policies',
  templateUrl: './policies.component.html',
  styleUrls: ['./policies.component.scss']
})
export class PoliciesComponent implements OnInit {

  logo = 'assets/img/caceis.png'

  menus = [
    {
      id: '1',
      title: '1. Introdução'
    },
    {
      id: '2',
      title: '2. Definições',
      sub: [
        {
          id: '2.1',
          title: '2.1. Objetivos da Santander Caceis'
        },
      ]
    },
    {
      id: '3',
      title: '3. Princípios de Privacidade',
      sub: [
        {
          id: '3.1',
          title: '3.1. A Santander Caceis é um operador ou controlador dos dados pessoais?'
        },
        {
          id: '3.2',
          title: '3.2. Coleta de dados'
        },
        {
          id: '3.3',
          title: '3.3. Compartilhamento'
        },
        {
          id: '3.4',
          title: '3.4. Transferência Internacional3.4. Transferência Internacional'
        },
        {
          id: '3.5',
          title: '3.5. Retenção de dados'
        },
      ]
    },
    {
      id: '4',
      title: '4. Direito dos Titulares'
    },
    {
      id: '5',
      title: '5. Cookies'
    },
    {
      id: '6',
      title: '6. Mudanças no documento'
    },
    {
      id: '7',
      title: '7. Vigência'
    }
  ]
  constructor() { }

  ngOnInit() {
  }

}
